<template>
  <div class="price">
       <div class="section">
      <div class="title">
        1.基础价：
      </div>
      <div class="text">
        基础价为商品的标示价格，是{{brand}}的建议零售价格，在菜单中标示为划线价格，非原价。
      </div>
    </div>
    <div class="section">
      <div class="title">
        2.促销价：
      </div>
      <div class="text">
        促销价为商品的促销价格，在菜单中标示为未划线价格，是当前{{brand}}给予消费者的优惠价格。促销价是以基础价为基数进行折扣或满减而获得的优惠价格。优惠券/代金券、满减等优惠活动与该促销价不能同时享有，具体详见优惠券/代金券使用规则与活动说明；
      </div>
    </div>
    <div class="section">
      <div class="title">
        3.规格加价：
      </div>
      <div class="text" v-if="brand === '茶猫'">
        因添加额外小料、加奶油等造成的规格加价金额，不享受饮品优惠活动；
      </div>
      <div class="text" v-else>
        因添加额外小料、加奶油、更换精品咖啡豆等造成的规格加价金额，不享受饮品优惠活动；
      </div>
    </div>
    <div class="section">
      <div class="title">
        4.规格加价划线价：
      </div>
      <div class="text">
        是指加各种小料当前的零售价格；
      </div>
    </div>
    <div class="section">
      <div class="title">
      5.优惠券/代金券、满减等优惠活动：
      </div>
      <div class="text" v-if="brand === '茶猫'">
        可在购买部分商品时，享受相应金额减免 (配送费等费用需另行支付) ，具体详见优惠券/代金券使用规则与活动说明；
      </div>
      <div class="text" v-else>
        可在购买部分商品时，享受相应金额减免 (配送费、奶油等费用需另行支付) ，具体详见优惠券/代金券使用规则与活动说明；
      </div>
    </div>
    <div class="section">
      <div class="title">
        6.仅供兑换：
      </div>
      <div class="text">
        仅供兑换商品为{{brand}}品牌合作定制商品，非直接售卖，可通过相关活动参与兑换。具体详见相关活动规则；
      </div>
    </div>
    <div class="section title">
      7.部分机场、车站、景点等特殊门店不参与限时促销活动，商品具体成交价格以订单结算页面为准；
    </div>
    <div class="section title">
      8.除所售卖产品外，其他物品仅为装饰目的，不在售卖范围内；
    </div>
    <div class="section title">
      9.如有疑问，可与店员或客服联系。
    </div>
  </div>
</template>

<script>
export default {
  name: 'Price',
  data() {
    return {
      brand: ''
    }
  },
  mounted () {
    this.brand = this.$config.env.VUE_APP_BRAND === "COTTI" ? "库迪咖啡" : "茶猫"
  }
}
</script>

<style lang="scss" scoped>
.price{
  height: 100%;
  padding: 28px 40px;
  background: var(--background-color);
  .section{
    margin-bottom: 24px;
  }
  .title{
    //height: 48px;
    font-size: 24px;
    font-weight: bold;
    color: #111111;
    line-height: 40px;
  }
  .text{
    font-size: 24px;
    font-weight: 400;
    color: #111111;
    line-height: 48px;
  }

}
</style>
